export default function scrollToTop (behavior = 'auto') {
  window.scrollTo({ top: 0, left: 0, behavior })
  // Scroll the main body wrapper (needed for iOS fixed-height layout)
  const el = document.querySelector('#body-wrapper')
  if (el) {
    el.scrollTo({ top: 0, left: 0, behavior })
  }
}



// WEBPACK FOOTER //
// ./src/library/scrollToTop.js